import React from 'react';
import { useTranslation } from 'react-i18next';

function AdminListFooter({
    totalItems,
    currentPage,
    totalPages,
    itemsPerPage,
    onItemsPerPageChange,
    onPrevious,
    onNext
}) {
    const { t } = useTranslation();

    return (
        <div className="mt-4 flex flex-col gap-3 rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm text-slate-600 lg:flex-row lg:items-center lg:justify-between">
            <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-3">
                <label className="flex items-center gap-2 font-medium text-slate-700">
                    <span>{t('adminCommon.itemsPerPage')}</span>
                    <select
                        value={itemsPerPage}
                        onChange={(e) => onItemsPerPageChange(Number(e.target.value))}
                        className="rounded-xl border border-slate-300 bg-white px-3 py-2 text-sm outline-none transition focus:border-[#1739bd]"
                    >
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={50}>50</option>
                    </select>
                </label>

                <span className="font-medium text-slate-600">
                    {t('adminCommon.totalItems')}: <span className="font-semibold text-slate-900">{totalItems}</span>
                </span>
            </div>

            <div className="flex items-center justify-between gap-3 sm:justify-end">
                <span className="text-xs font-medium uppercase tracking-[0.12em] text-slate-500">
                    {t('adminCommon.pageOf', {
                        page: totalItems === 0 ? 0 : currentPage,
                        total: totalItems === 0 ? 0 : totalPages
                    })}
                </span>
                <div className="flex items-center gap-2">
                    <button
                        type="button"
                        onClick={onPrevious}
                        disabled={currentPage <= 1}
                        className="inline-flex items-center justify-center rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm font-semibold text-slate-700 transition hover:bg-slate-100 disabled:cursor-not-allowed disabled:opacity-50"
                    >
                        {t('adminCommon.prev')}
                    </button>
                    <button
                        type="button"
                        onClick={onNext}
                        disabled={currentPage >= totalPages || totalPages === 0}
                        className="inline-flex items-center justify-center rounded-xl border border-[#1739bd] bg-[#1739bd] px-3 py-2 text-sm font-semibold text-white transition hover:bg-indigo-700 disabled:cursor-not-allowed disabled:opacity-50"
                    >
                        {t('adminCommon.next')}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default AdminListFooter;